function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M109.793 8.743H86.365v.004h-5.851V35l5.858-5.267V14.619h16.886l6.535-5.876z",
  fill: "#FA4504"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M119.534.003H89.23v27.188l5.853-5.264V5.88H113l6.535-5.877z",
  fill: "#FA4504"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.078 6.527v28.47h5.855V.002l-5.855 6.524z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.055 0L19.468 12.912 7.881 0H2.027L0 .004 7.881 8.78l7.648 8.52 3.94 4.389 3.938-4.39 7.648-8.519L38.933.005 36.913 0h-5.858zM0 .003l3.604 4.015L0 .003zM0 34.997h5.854V10.819L0 4.295v30.702zM78.494 0h-5.858L61.049 12.912 49.462 0h-5.854L41.58.004l7.881 8.777 7.648 8.52 1.012 1.13 5.858 6.527v-6.534l1.008-1.123 7.648-8.52L80.514.005 78.494 0zM58.122 34.997h5.858v-5.268l-5.858-6.527v11.795zM158.5 5.876V.003h-27.908v5.873H158.5zM122.182 34.996h5.854v-20.17l-5.854-6.524v26.694zM128.036 10.535V.003h-5.854v4.008l5.854 6.524z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M147.473 16.243V.003h-5.854V9.72l5.854 6.524zM141.619 14.014v20.982h5.854V20.534l-5.854-6.52z",
  fill: "#fff"
});

function SvgLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 35,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgLogoWhite;